var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3968FF",
    d: "M6.258 6.5a.24.24 0 0 0 .222-.222V5.39a.225.225 0 0 0-.222-.223H4.443a3.24 3.24 0 0 1 2.63-1.352 3.264 3.264 0 0 1 3.259 3.26 3.25 3.25 0 0 1-3.26 3.259 3.2 3.2 0 0 1-2.166-.815c-.092-.074-.222-.074-.296.019l-.63.63c-.092.092-.092.24 0 .314a4.6 4.6 0 0 0 3.093 1.185 4.576 4.576 0 0 0 4.592-4.574A4.57 4.57 0 0 0 7.11 2.501a4.5 4.5 0 0 0-3.445 1.518V2.556a.24.24 0 0 0-.222-.222h-.889a.225.225 0 0 0-.222.222v3.722c0 .112.093.223.222.223z"
  })));
};
export default SvgUndo;